// import { SystemIcon } from '@monorepo/nova-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PositionViewType } from '@hub/features/account-dashboard/types';
import { ToggleButtonGroup } from '@mui/material';
import { Stack, ToggleButtons, ToggleButtonSize } from '@monorepo/nova-ui';

interface HeaderRightSectionProps {
  selectedViews: PositionViewType;
  onSelectionChange: (view: PositionViewType) => void;
}

export const HeaderRightSection: FC<HeaderRightSectionProps> = ({
  selectedViews,
  onSelectionChange,
}) => {
  const { t } = useTranslation('activityLog');
  const handleToggleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newView: PositionViewType | null,
  ) => {
    // Ensure a value is selected (prevent deselection)
    if (newView !== null) {
      onSelectionChange(newView);
    }
  };

  return (
    <Stack direction="row" alignItems="center" gap={5}>
      <ToggleButtonGroup
        value={selectedViews}
        onChange={handleToggleChange}
        aria-label={t('positionViewSelection')}
        exclusive
      >
        {Object.values(PositionViewType).map((variant: PositionViewType) => (
          <ToggleButtons
            key={variant}
            value={variant}
            aria-label={`${t(variant, {
              defaultValue: variant.charAt(0).toUpperCase() + variant.slice(1),
            })} ${t('positions', { defaultValue: 'positions' })}`}
            color="info"
            size={ToggleButtonSize.SM}
          >
            {t(variant, {
              defaultValue: variant.charAt(0).toUpperCase() + variant.slice(1),
            })}
          </ToggleButtons>
        ))}
      </ToggleButtonGroup>
      {/* <SystemIcon iconName="ColumnsPlusRight" />
      <SystemIcon iconName="CornersOut" /> */}
    </Stack>
  );
};
